import styled from 'styled-components';

import { COLOR } from 'constants/color';

export const GenerateIcon = styled.div`
  display: flex;
  border: 1px solid ${COLOR.purpel['purpel-6']};
  border-radius: 12px;
  padding: 8px 16px 8px 14px;

  &:hover {
    cursor: pointer;
    opacity: 0.6;
  }
`;

export const OveralExercise = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid rgba(34, 34, 34, 0.07);
  background: rgba(34, 34, 34, 0.07);
  border-radius: 12px;
  padding: 8px 14px;
`;

export const SwitchContainer = styled.div`
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: 12px;
  padding: 4px 12px;
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const Grid_3 = styled.div`
  display: grid;
  grid-gap: 12px;
  margin-bottom: 12px;
  grid-template-columns: repeat(4, 1fr);

  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;
